import style from "./ProduktyTech.module.css";
import { useContext, useState } from "react";
import { ModalInsertContext } from "context/ModalInsertContext";
import { TechnologyContext } from "context/TechnologyContext";
import { AppContext } from "context/AppContext";
import { reg_int, reg_txt } from "utils/initialvalue";
import Logo_ustawienia from "assets/settings.svg";
import Logo_ustawienia2 from "assets/refresh_green2.svg";
import ProduktyTechMenu from "./ProduktyTechMenu";
import { ifNoTextSetNull } from "actions/ifNoTextSetNull";

import { createArkuszeFromElemenets } from "actions/createArkusze/STAREcreateArkuszeFromElements";
import { input1632toElement } from "actions/input1632toElement";
import { useArkusze } from "hooks/useArkusze";
import GenerujUlotki from "./components/GenerujUlotki";
import GenerujBroszure from "./components/GenerujBroszure";
import GenerujOkladki from "./components/GenerujOkladki";
import ElementyTechManager from "../elementytechmanager/ElementyTechManager";
import { Play, RefreshCcw, RotateCcw } from "lucide-react";
import { useArkuszeAuto } from "hooks/arkusze/useArkuszeAuto";

export default function ProduktyTech() {
  const {arkusze,produktyTech,rodzajLegi, setRodzajLegi,iloscLeg, setIloscLeg,iloscOkladek, setIloscOkladek} = useContext(TechnologyContext);


  const [showOkladki, setShowOkladki] = useState(false);
  const { autoArk } = useArkuszeAuto();


  const styles = {
    
    buttonGroup: { display: 'flex',marginTop:'3px', height:'50px', gap:'10px',backgroundColor: 'transparent', padding: '10px', borderRadius: '12px', border: 'none' },
    navButton: (active, activeColor = '#30639b') => ({
      padding: '0px 10px', borderRadius: '8px', border: '1px solid #c2c2c2', cursor: 'pointer',
      backgroundColor: active ? activeColor : '#fdfdfd', color: active ? '#fff' : '#64748b', fontWeight: 'normal', fontSize: '13px'
    }),
   
  };


  return (
    <div className={style.container}>
      <div className={style.produkt}>
        <div className={style.produkt_menu_button}>
          <p style={{ color: "grey", fontSize: "1.5rem", paddingTop: "10px" }}> Druk </p>
<div>
   {  (arkusze.filter(x=> x.delete != true).length == 0)   &&   <div style={{ display: "flex", gap: "20px" }}>

            <div style={styles.buttonGroup}>
{[2,4, 8, 12, 16, 24, 32].map(num => (
  <button 
    title="Rodzaj legi"
    key={num} 
    onClick={() => setRodzajLegi(num)} 
    style={styles.navButton(rodzajLegi === num, num >= 16 ? '#575757' : '#575757')}
  >
    {num} 
  </button>
))}
            </div>

                        <div style={styles.buttonGroup}>
{[1, 2, 3, 4].map(num => (
  <button 
    title="Ilość leg na arkuszu"

    key={num} 
    onClick={() => {
      setIloscLeg(num)

    }} 
    style={styles.navButton(iloscLeg === num, num >= 16 ? '#575757' : '#575757')}
    // style={styles.navButton(iloscLeg === num, num >= 16 ? '#f59e0b' : '#030303')}
  >
   x {num} 
  </button>
))}
            </div>



                              <div style={styles.buttonGroup} >
{[1, 2, 3, 4].map(num => (
  <button 
    title="Ilość okładek na arkuszu"

    key={num} 
    onClick={() => setIloscOkladek(num)} 
    style={styles.navButton(iloscOkladek === num, num >= 16 ? '#575757' : '#575757')}
    // style={styles.navButton(iloscLeg === num, num >= 16 ? '#f59e0b' : '#30639b')}
  >
    {num} {num === 1 ? 'okładka' : 'okładki'} {/* Przykład dynamicznej etykiety */}
   {/* {num} okładki */}
  </button>
))}

       
            </div>      

 {/* <button onClick={()=>{autoArk()}}                 style={{
                  padding: "2px 6px",
                  background: "rgb(245, 157, 6)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  // fontWeight: "600",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "background 0.2s",
                  height:"30px",
                  marginTop:"10px"
                }}> 
       < RefreshCcw size={18} style={{color:'rgb(254, 254, 252)',marginRight:'5px',marginLeft:'0px'}}/> Generuj arkusze
        </button> */}

        <GenerujArkusze/>

         {/* {produktyTech[0].typ ==1 && showOkladki && <GenerujOkladki />} 
         {produktyTech[0].typ ==1 && <GenerujBroszure setShowOkladki={setShowOkladki} />} 
         {produktyTech[0].typ ==2 && <GenerujUlotki />}  */}
    </div>
    
    }
</div>




        </div>
                    {  (arkusze.filter(x=> x.delete != true).length == 0)   &&  <ElementyTechManager/>}

        <ProduktyTable2 />
      </div>
    </div>
  );
}

//--------------------------




function ProduktyTable2() {
  const contextTech = useContext(TechnologyContext);
  const produktyTech = contextTech.produktyTech;

  return (
    <div title={JSON.stringify(produktyTech[0], null, 2)} className={style.main2}>
      <div className={style.row1}>
        <Typ row={produktyTech[0]} />
        <Naklad row={produktyTech[0]} />
        <Nadkomplet row={produktyTech[0]} />
        <Strony row={produktyTech[0]} />
        <FormatX row={produktyTech[0]} />
        <FormatY row={produktyTech[0]} />
        <RodzajOprawy row={produktyTech[0]} />
        <OpisPostacPapieru row={produktyTech[0]} />
        <OpisSzerokoscArkusza row={produktyTech[0]} />
        <OpisWysokoscArkusza row={produktyTech[0]} />
        <OpisRodzajLegi row={produktyTech[0]} />
        <OpisIloscLeg row={produktyTech[0]} />
        <Nazwa row={produktyTech[0]} />
        <Uwagi row={produktyTech[0]} />
      </div>
    </div>
  );
}

const MenuProduktyBtn = ({ row, showMenu, setShowMenu }) => {

   const techContext = useContext(TechnologyContext);
  const produktyTech = techContext.produktyTech;

  const { createArkuszeFromElemenets, createUlotki } = useArkusze();
 
      return (
    
    <div className={style.menu_produkty}>
      <img

        className={ style.iconMenuBtn}
        src={Logo_ustawienia2}
        title="Auto wszystkie arkusze + legi"
        onClick={() => {

          if (produktyTech[0].typ == 1) {
            createArkuszeFromElemenets();
          }
          if (produktyTech[0].typ == 2) {
          createUlotki()

          }
 
         
        }}
        alt="x"
      />

    </div>
  );
  

};

const GenerujArkusze = ({ }) => {

   const techContext = useContext(TechnologyContext);
  const produktyTech = techContext.produktyTech;
  const elementyTech = techContext.elementyTech;
  const { autoArk } = useArkuszeAuto();


  const { createArkuszeFromElemenets, createUlotki } = useArkusze();

function sprawdzCzyKazdyElementMaLegi(tablica) {
  if (!Array.isArray(tablica) || tablica.length === 0) return false;

  return tablica.every(item => 
    Array.isArray(item.kolejnoscLeg) && item.kolejnoscLeg.length > 0
  );
}

{if(sprawdzCzyKazdyElementMaLegi(elementyTech) == false) return null}
 
      return (
    
    <div className={style.menu_produkty}>
      <img

        className={ style.iconMenuBtn}
        src={Logo_ustawienia2}
        title="Auto wszystkie arkusze + legi"
        onClick={() => {       autoArk() 
        }}
        alt="x"
      />

    </div>
  );
  

};



function Typ({ row }) {
const contextApp = useContext(AppContext);
const contextTech = useContext(TechnologyContext);  
const updateRowProduktyTech = contextTech.updateRowProduktyTech;


  return (
    <div className={style.col_dane}>
      <label className={style.label}> Typ </label>
      <select
        className={style.select}
        value={row?.typ}
           readOnly={true}
        // onChange={(e) => {
        //   updateRowProduktyTech({
        //     ...row,
        //     typ: e.target.value, update:true
        //   });
        // }}
      >
        {}
        {contextApp.productType.map((option) => (
          <option key={option.id} value={option.id}>
            {option.nazwa}
          </option>
        ))}
      </select>
    </div>
  );
}

function Nazwa({ row }) {

const contextTech = useContext(TechnologyContext);  
const updateRowProduktyTech = contextTech.updateRowProduktyTech;
  return (
    <div className={style.col_dane}>
      <label className={style.label}> Nazwa </label>
      <input
        className={style.input}
        value={row?.nazwa}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            updateRowProduktyTech({
              ...row,
              nazwa: e.target.value, update:true
            });
          }
        }}
      ></input>
    </div>
  );
}

function Naklad({ row }) {

  const contextApp = useContext(AppContext);
  const contextTech = useContext(TechnologyContext);  
  const updateRowProduktyTech = contextTech.updateRowProduktyTech;
  const produkty = contextTech.produkty
  return (
    <div className={style.col_dane}>
      <label className={style.label}> Nakład </label>
      <input
        className={produkty[0]?.naklad == row?.naklad ? style.input :style.inputError} title={"W zamówienie: "+produkty[0]?.naklad } type="text"
        value={row?.naklad}
        onChange={(e) => {
          // const re = /^[0-9]+$/;
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            updateRowProduktyTech({
              ...row,
              naklad: ifNoTextSetNull(e.target.value),update:true
            });
          }
        }}
      ></input>
    </div>
  );
}


function OpisPostacPapieru({ row }) {
  return (
    <div className={style.col_dane}>
      <label className={style.label}> Papier </label>
      <input
      disabled
        className={style.input}
      ></input>
    </div>
  );
}


function OpisSzerokoscArkusza({ row }) {
  return (
    <div className={style.col_dane}>
      <label className={style.label}> ark. szer. </label>
      <input
      disabled
        className={style.input}
      ></input>
    </div>
  );
}

function OpisWysokoscArkusza({ row }) {
  return (
    <div className={style.col_dane}>
      <label className={style.label}> ark. wys. </label>
      <input
      disabled
        className={style.input}
      ></input>
    </div>
  );
}

function OpisRodzajLegi({ row }) {
  return (
    <div className={style.col_dane}>
      <label className={style.label}> lega  </label>
      <input
      disabled
        className={style.input}
      ></input>
    </div>
  );
}


function OpisIloscLeg({ row }) {
  return (
    <div className={style.col_dane}>
      <label className={style.label}> ilosc leg</label>
      <input
      disabled
        className={style.input}
      ></input>
    </div>
  );
}


function Strony({ row }) {
  const contextApp = useContext(AppContext);
  const contextTech = useContext(TechnologyContext);  
  const updateRowProduktyTech = contextTech.updateRowProduktyTech;
  const produkty = contextTech.produkty

  return (
    <div className={style.col_dane}>
      <label className={style.label}> Strony </label>
      <input
      // disabled
                className={produkty[0]?.ilosc_stron == row?.ilosc_stron ?style.input :style.inputError} title={"W zamówienie: "+produkty[0]?.ilosc_stron } type="text"
        value={row?.ilosc_stron}
        onChange={(e) => {
          // const re = /^[0-9]+$/;
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            updateRowProduktyTech({
              ...row,
              ilosc_stron: ifNoTextSetNull(e.target.value),
              update: true
            });
          }
        }}

      ></input>
    </div>
  );
}
function Nadkomplet({ row }) {
  const contextApp = useContext(AppContext);
  const contextTech = useContext(TechnologyContext);  
  const updateRowProduktyTech = contextTech.updateRowProduktyTech;

  return (
    <div className={style.col_dane}>
      <label className={style.label}> Nadkomplet </label>
      <input
      disabled
        className={style.input}
        // value={row?.ilosc_stron}
        // onChange={(e) => {
      
        //   if (e.target.value === "" || reg_int.test(e.target.value)) {
        //     updateRowProduktyTech({
        //       ...row,
        //       ilosc_stron: ifNoTextSetNull(e.target.value),
        //       update: true
        //     });
        //   }
        // }}

      ></input>
    </div>
  );
}

function FormatX({ row }) {
  const contextApp = useContext(AppContext);
  const contextTech = useContext(TechnologyContext);  
  const updateRowProduktyTech = contextTech.updateRowProduktyTech;
  const produkty = contextTech.produkty

  return (
    <div className={style.col_dane}>
      <label className={style.label}> Szer. </label>
      <input
      // disabled
    
        className={produkty[0]?.format_x == row?.format_x ?style.input :style.inputError} title={"W zamówienie: "+produkty[0]?.format_x } type="text"
        
        value={row?.format_x}
        onChange={(e) => {
          const re = /^\d{0,6}(?:\,\d{0,2}){0,1}$/;

          if (e.target.value === "" || re.test(e.target.value)) {
            updateRowProduktyTech({
              ...row,
              format_x: ifNoTextSetNull(e.target.value),
              update: true
            });
          }
        }}
      ></input>
    </div>
  );
}
function FormatY({ row }) {
  const contextApp = useContext(AppContext);
  const contextTech = useContext(TechnologyContext);  
  const updateRowProduktyTech = contextTech.updateRowProduktyTech;
  const produkty = contextTech.produkty

  return (
    <div className={style.col_dane}>
      <label className={style.label}> Wys. </label>
      <input
      // disabled
      className={produkty[0]?.format_y == row?.format_y ?style.input :style.inputError} title={"W zamówienie: "+produkty[0]?.format_y } type="text"

        value={row?.format_y}
        onChange={(e) => {
          const re = /^\d{0,6}(?:\,\d{0,2}){0,1}$/;

          if (e.target.value === "" || re.test(e.target.value)) {
            updateRowProduktyTech({
              ...row,
              format_y: ifNoTextSetNull(e.target.value),
              update: true
            });
          }
        }}
      ></input>
    </div>
  );
}

function RodzajOprawy({ row, handleChangeCardOprawa }) {
  const contextModalInsert = useContext(ModalInsertContext);
  const contextApp = useContext(AppContext);
  const contextTech = useContext(TechnologyContext);  

  const produkty = contextTech.produkty

  return (
    <div className={style.col_dane}>
      <label className={style.label}> Oprawa </label>
      <select
        disabled
        // className={style.select_oprawa}
      className={produkty[0]?.oprawa == row?.oprawa ?style.input :style.inputError} title={"W zamówienie: "+produkty[0]?.oprawa } type="text"

        value={row?.oprawa}

      >
         {contextApp.procesList?.filter(x=>x.nazwa_id==6).map((option) => (
          <option key={option.id} value={option.id}>
            {option.typ} {option.rodzaj} 
          </option>
        ))}
      </select>
    </div>
  );
}

function Uwagi({ row }) {
  const contextTech = useContext(TechnologyContext);  
  const updateRowProduktyTech = contextTech.updateRowProduktyTech;
  return (
    <div className={style.col_dane}>
      <label className={style.label}> Uwagi </label>
      <input
        className={style.input}
        value={row?.uwagi}
        onChange={(e) => {
          const re = /^[a-zA-Z0-9_+\sąćęłńóśźżĄĘŁŃÓŚŹŻ]+$/;
          if (e.target.value === "" || re.test(e.target.value)) {
            updateRowProduktyTech({
              ...row,
              uwagi: e.target.value,
              update: true
            });
          }
        }}
      ></input>
    </div>
  );
}

//--------------------









